/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import Avatar from 'components/shared/Avatar';
import PropTypes from 'prop-types';

const UserNameAndIcon = ({ account, isSidebarExpanded, showLogout, hideLogout, logout, handleAvatarClicked }) => {
  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        position: 'absolute',
        left: '0px',
        bottom: '0px',
        right: '0px',
        padding: '20px'
      }}
      onMouseOver={showLogout}
      onMouseOut={hideLogout}
    >
      <Avatar account={account} onClick={handleAvatarClicked}/>
      <div
        css={{
          flex: '1',
          height: '36px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          transition: 'all ease-in-out 0.3s',
          transform: isSidebarExpanded ? 'translateX(0px)' : 'translateX(50px)',
          opacity: isSidebarExpanded ? '1' : '0',
        }}
      >
        <div
          css={{
            color: '#fff',
          }}
        >
          { account?.data?.name || 'Me' }
        </div>
        <div
          css={{
            color: '#788287',
            fontSize: '13px',
            lineHeight: '13px',
            cursor: 'pointer',
            '&:hover': {
              color: '#fff',
            }
          }}
          onClick={logout}
        >
          Log Out
        </div>
      </div>
    </div>
  );
};

UserNameAndIcon.propTypes = {
  name: PropTypes.string,
  image: PropTypes.string
};

UserNameAndIcon.defaultProps = {
  name: 'Me',
  image: null
};

export default UserNameAndIcon;
